import { render, staticRenderFns } from "./changesAftercare.vue?vue&type=template&id=5b25ffc2&scoped=true"
import script from "./changesAftercare.vue?vue&type=script&lang=js"
export * from "./changesAftercare.vue?vue&type=script&lang=js"
import style0 from "./changesAftercare.vue?vue&type=style&index=0&id=5b25ffc2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b25ffc2",
  null
  
)

export default component.exports